import React from 'react';
import PropTypes from 'prop-types';

// TODO: Handle different elevations / shadow options
// TODO: Get shadow style from theme? (could make shadow color based on primary brand color / easier on eyes)
const Card = React.memo(({ children, className, onClick, style, tag, ...props }) => {
  const Tag = tag;
  return (
    <Tag className={`${className || ''}`} style={style} onClick={onClick} {...props}>
      {children}
    </Tag>
  );
});

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  // Don't want padding? Pass in your own style property
  style: PropTypes.shape({}),
  tag: PropTypes.string,
  onClick: PropTypes.func
};

Card.defaultProps = {
  className: null,
  onClick: null,
  style: {},
  tag: 'div'
};

export default Card;
